import { Component, Input, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MotivationFullDetails } from 'src/app/all-motivations/model/all-motivations.interface';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { MoovData, MoovInstanceData } from 'src/app/moov-common/services/challenge/challenges-data';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';

@Component({
  selector: 'app-mini-moov-view',
  templateUrl: './mini-moov-view.component.html',
  styleUrls: ['./mini-moov-view.component.scss']
})
export class MiniMoovViewComponent extends BaseComponent implements OnInit {
  @Input() moovDetails: MoovData;
  @Input() activeMoovDetails: MoovInstanceData;
  @Input() isPastMoov: boolean = false;
  @Input() isActiveMoov: boolean = false;
  @Input() isRecommendedMoov: boolean = false;
  @Input() hasActiveInstance: boolean = false;
  @Input() hasPastInstance: boolean = false;
  @Input() isBestMoov: boolean = false;
  @Input() presentCounterpartDetails: boolean = false;
  @Input() isMoovForSelf : boolean = false;
  motivationDetails : MotivationFullDetails;

  isImportant = false;
  timeLeftText: string;
  moovsImagesRootFolder = 'assets/moovs/';
  
  constructor(public translate: TranslateService,
              private readonly motivationsService: AbstractMotivationsService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isImportant = this.moovDetails.score > 50;
    this.getMotivationDetails();
  }

  ngOnChanges(changes : SimpleChanges){
    if (changes.moovDetails.currentValue != changes.moovDetails.previousValue && !changes.moovDetails.firstChange){
      this.isImportant = this.moovDetails.score > 50;
      this.getMotivationDetails();
    }
  } 

  getTimeLeftforMoovText(){
    let timeLeftText = ""; 
    if (!this.isPastMoov && this.isActiveMoov){
      if (!this.activeMoovDetails.isOverdue){
        const plannedEndDate = new Date(this.activeMoovDetails.plannedEndDate);
        const currentTime = new Date();
        const daysLeft = Math.round((plannedEndDate.getTime() - currentTime.getTime())/(3600*24*1000));
  
        // console.log (`in setTimeLeftForMoov planned ${plannedEndDate.getTime()} days left ${daysLeft}`);
  
        if (daysLeft > 1) {
          if (daysLeft === 2) {
            timeLeftText = this.translate.instant("moovView.dueIn2Days");
          } else {
            timeLeftText = this.translate.instant("moovView.dueIn", { value: daysLeft });
          }
        }
        else if (daysLeft === 1)
        {
          timeLeftText = this.translate.instant("moovView.dueTomorrow");
        }
        else{
          timeLeftText = this.translate.instant("moovView.dueToday");
        }
      }
      else{
        timeLeftText = this.translate.instant("moovView.overdue");;
      }
    }

    return timeLeftText;
  }

  getCounterpartInitials(activeMoov: MoovInstanceData): string{
    if (activeMoov.counterpartFirstName && activeMoov.counterpartLastName){
      const counterpartInitials = activeMoov.counterpartFirstName.substring(0, 1) + activeMoov.counterpartLastName.substring(0,1);
      return counterpartInitials;
    }

    return "";
  }

  timeAgo(date: Date) : string{
    return this.utilsService.dateToTimeAgo(date);
  }

  getMotivationDetails(): void{
    if (this.moovDetails != undefined){
      // console.log(`in MTW getMoptivationDetails motivation id is ${this.moovDetails.motivationId}`);
      this.motivationDetails = this.motivationsService.getPartialMotivationDetails(this.moovDetails.motivationId);
    }
  }
}
